module.exports = __webpack_public_path__ + "media/images/emoticons/down-d253698280ed4582fca2825f67df28a6.gif";